import { Injectable, signal } from '@angular/core';
import { ModalDefinition } from '@utils/types';

@Injectable({ providedIn: 'root' })
export class ModalService {
  private _currentModal = signal<ModalDefinition | null>(null);

  currentModal = this._currentModal.asReadonly();

  open(modal: ModalDefinition) {
    this._currentModal.set(modal);
  }

  close() {
    this._currentModal.set(null);
  }
}
